import React, { useRef } from 'react'

export function Alert({ type, message, onClick, isClose = false }) {
  const isHidden = useRef(true)

  const cssClasses = {
    success: 'alert alert-success',
    error: 'alert alert-error',
    info: 'alert alert-info',
    warning: 'alert alert-warning',
  }

  if (isClose) {
    return null
  }

  return isHidden ? null : (
    <div className="m-3">
      <div className={cssClasses[type]}>
        <span dangerouslySetInnerHTML={{ __html: message }} />
        <button className="close" onClick={onClick}>
          &times;
        </button>
      </div>
    </div>
  )
}
export default Alert
